import w from "../../../@babel/runtime/helpers/esm/slicedToArray2.mjs";
import * as H from "react";
import { useRef as u, useEffect as M } from "react";
import R from "../../../rc-util/es/Dom/findDOMNode.mjs";
import l from "../../../rc-util/es/raf.mjs";
import x from "../utils/CacheMap.mjs";
function q(g, c, i) {
  var h = H.useState(0), m = w(h, 2), d = m[0], v = m[1], e = u(/* @__PURE__ */ new Map()), f = u(new x()), s = u();
  function a() {
    l.cancel(s.current);
  }
  function p() {
    a(), s.current = l(function() {
      e.current.forEach(function(t, r) {
        if (t && t.offsetParent) {
          var n = R(t), o = n.offsetHeight;
          f.current.get(r) !== o && f.current.set(r, n.offsetHeight);
        }
      }), v(function(t) {
        return t + 1;
      });
    });
  }
  function E(t, r) {
    var n = g(t), o = e.current.get(n);
    r ? (e.current.set(n, r), p()) : e.current.delete(n), !o != !r && (r ? c == null || c(t) : i == null || i(t));
  }
  return M(function() {
    return a;
  }, []), [E, p, f.current, d];
}
export {
  q as default
};
//# sourceMappingURL=useHeights.mjs.map
